import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '@/services/CredentialsService.js'

const AuthRepository = RepositoryFactory.get('auth')

class AuthService {
  static async login (email, password, remember) {
    try {
      let result = await AuthRepository.login(email, password, remember)
      let userData = result.data.data.user
      let permissions = result.data.data.permissions
      let authenticationData = result.data.data.authentication
      let currentTenantId = result.data.data.current_tenant_id
      let tenantsData = result.data.data.tenants

      let userDisabled = userData.disabled_web

      if (!userDisabled) {
        CredentialsService.setUser(userData)
        CredentialsService.setPermissions(permissions)
        CredentialsService.setAuthentication(authenticationData)
        CredentialsService.setCurrentTenantId(currentTenantId)
        CredentialsService.setTenants(tenantsData)
      }

      return {
        success: true,
        disabled: userDisabled
      }
    } catch (error) {
      console.log(error)
    }
    return {
      success: false
    }
  }

  static async passwordRequest (email, url) {
    try {
      return await AuthRepository.passwordRequest(email, url)
    } catch (error) {
      console.log(error)
    }
  }

  static async passwordReset (token, email, password, passwordConfirmation) {
    try {
      return await AuthRepository.passwordReset(token, email, password, passwordConfirmation)
    } catch (error) {
      console.log(error)
    }
  }
}

export default AuthService
